import axiosInstance from '@/core/js/interceptor';
import { AuthService } from './AuthService';

export const CommonService = {
    getBranch: (data) =>
        axiosInstance.post(
            '/api/common/getBranch',
            {
                branch_id: AuthService.getActiveBranchId(),
                accounting_period_id: AuthService.getActiveAccountingPeriodId(),
                ...data
            },
            { validateStatus: () => true }
        ),
    getProvinces: (data) =>
        axiosInstance.post(
            '/api/common/getProvinces',
            {
                branch_id: AuthService.getActiveBranchId(),
                accounting_period_id: AuthService.getActiveAccountingPeriodId(),
                ...data
            },
            { validateStatus: () => true }
        ),
    getPartyGroups: (data) =>
        axiosInstance.post(
            '/api/common/getPartyGroups',
            {
                branch_id: AuthService.getActiveBranchId(),
                accounting_period_id: AuthService.getActiveAccountingPeriodId(),
                ...data
            },
            { validateStatus: () => true }
        ),
    getPartyTypes: (data) =>
        axiosInstance.post(
            '/api/common/getPartyTypes',
            {
                branch_id: AuthService.getActiveBranchId(),
                accounting_period_id: AuthService.getActiveAccountingPeriodId(),
                ...data
            },
            { validateStatus: () => true }
        ),
    getPartyGrades: (data) =>
        axiosInstance.post(
            '/api/common/getPartyGrades',
            {
                branch_id: AuthService.getActiveBranchId(),
                accounting_period_id: AuthService.getActiveAccountingPeriodId(),
                ...data
            },
            { validateStatus: () => true }
        ),
    getPartyFbrStatus: (data) =>
        axiosInstance.post(
            '/api/common/getPartyFbrStatus',
            {
                branch_id: AuthService.getActiveBranchId(),
                accounting_period_id: AuthService.getActiveAccountingPeriodId(),
                ...data
            },
            { validateStatus: () => true }
        ),
    getEmployeeDesignations: (data) =>
        axiosInstance.post(
            '/api/common/getEmployeeDesignations',
            {
                branch_id: AuthService.getActiveBranchId(),
                accounting_period_id: AuthService.getActiveAccountingPeriodId(),
                ...data
            },
            { validateStatus: () => true }
        ),
    getSalesman: (data) =>
        axiosInstance.post(
            '/api/common/getSalesman',
            {
                branch_id: AuthService.getActiveBranchId(),
                accounting_period_id: AuthService.getActiveAccountingPeriodId(),
                ...data
            },
            { validateStatus: () => true }
        ),
    getEmployee: (data) =>
        axiosInstance.post(
            '/api/common/getEmployee',
            {
                branch_id: AuthService.getActiveBranchId(),
                accounting_period_id: AuthService.getActiveAccountingPeriodId(),
                ...data
            },
            { validateStatus: () => true }
        ),
    getSalesDesingationHierarchy: (data) =>
        axiosInstance.post(
            '/api/common/getSalesDesingationHierarchy',
            {
                branch_id: AuthService.getActiveBranchId(),
                accounting_period_id: AuthService.getActiveAccountingPeriodId(),
                ...data
            },
            { validateStatus: () => true }
        ),
    getTowns: (data) =>
        axiosInstance.post(
            '/api/common/getTowns',
            {
                branch_id: AuthService.getActiveBranchId(),
                accounting_period_id: AuthService.getActiveAccountingPeriodId(),
                ...data
            },
            { validateStatus: () => true }
        ),
    getCities: (data) =>
        axiosInstance.post(
            '/api/common/getCities',
            {
                branch_id: AuthService.getActiveBranchId(),
                accounting_period_id: AuthService.getActiveAccountingPeriodId(),
                ...data
            },
            { validateStatus: () => true }
        ),
    getPartyMaxCode: (data) =>
        axiosInstance.post(
            '/api/common/getPartyMaxCode',
            {
                branch_id: AuthService.getActiveBranchId(),
                accounting_period_id: AuthService.getActiveAccountingPeriodId(),
                ...data
            },
            { validateStatus: () => true }
        ),
    getAccountOpeningBalance: (data) =>
        axiosInstance.post(
            '/api/common/getAccountOpeningBalance',
            {
                branch_id: AuthService.getActiveBranchId(),
                accounting_period_id: AuthService.getActiveAccountingPeriodId(),
                ...data
            },
            { validateStatus: () => true }
        ),
    getRawProductTypes: (data) =>
        axiosInstance.post(
            '/api/common/getRawProductTypes',
            {
                branch_id: AuthService.getActiveBranchId(),
                accounting_period_id: AuthService.getActiveAccountingPeriodId(),
                ...data
            },
            { validateStatus: () => true }
        ),
    getRawProductCategories: (data) =>
        axiosInstance.post(
            '/api/common/getRawProductCategories',
            {
                branch_id: AuthService.getActiveBranchId(),
                accounting_period_id: AuthService.getActiveAccountingPeriodId(),
                ...data
            },
            { validateStatus: () => true }
        ),
    getRawProductGroups: (data) =>
        axiosInstance.post(
            '/api/common/getRawProductGroups',
            {
                branch_id: AuthService.getActiveBranchId(),
                accounting_period_id: AuthService.getActiveAccountingPeriodId(),
                ...data
            },
            { validateStatus: () => true }
        ),
    getRawProductSubGroups: (data) =>
        axiosInstance.post(
            '/api/common/getRawProductSubGroups',
            {
                branch_id: AuthService.getActiveBranchId(),
                accounting_period_id: AuthService.getActiveAccountingPeriodId(),
                ...data
            },
            { validateStatus: () => true }
        ),
    getProductUnits: (data) =>
        axiosInstance.post(
            '/api/common/getProductUnits',
            {
                branch_id: AuthService.getActiveBranchId(),
                accounting_period_id: AuthService.getActiveAccountingPeriodId(),
                ...data
            },
            { validateStatus: () => true }
        ),
    getWarehouseRows: (data) =>
        axiosInstance.post(
            '/api/common/getWarehouseRows',
            {
                branch_id: AuthService.getActiveBranchId(),
                accounting_period_id: AuthService.getActiveAccountingPeriodId(),
                ...data
            },
            { validateStatus: () => true }
        ),
    getProductTypesByParams: (data) =>
        axiosInstance.post(
            '/api/common/getProductTypesByParams',
            {
                branch_id: AuthService.getActiveBranchId(),
                accounting_period_id: AuthService.getActiveAccountingPeriodId(),
                ...data
            },
            { validateStatus: () => true }
        ),
    getProductGroups: (data) =>
        axiosInstance.post(
            '/api/common/getProductGroups',
            {
                branch_id: AuthService.getActiveBranchId(),
                accounting_period_id: AuthService.getActiveAccountingPeriodId(),
                ...data
            },
            { validateStatus: () => true }
        ),
    getProductSubGroups: (data) =>
        axiosInstance.post(
            '/api/common/getProductSubGroups',
            {
                branch_id: AuthService.getActiveBranchId(),
                accounting_period_id: AuthService.getActiveAccountingPeriodId(),
                ...data
            },
            { validateStatus: () => true }
        ),
    getProductBrands: (data) =>
        axiosInstance.post(
            '/api/common/getProductBrands',
            {
                branch_id: AuthService.getActiveBranchId(),
                accounting_period_id: AuthService.getActiveAccountingPeriodId(),
                ...data
            },
            { validateStatus: () => true }
        ),
    getProductVariants: (data) =>
        axiosInstance.post(
            '/api/common/getProductVariants',
            {
                branch_id: AuthService.getActiveBranchId(),
                accounting_period_id: AuthService.getActiveAccountingPeriodId(),
                ...data
            },
            { validateStatus: () => true }
        ),
    getProductPackagingVariants: (data) =>
        axiosInstance.post(
            '/api/common/getProductPackagingVariants',
            {
                branch_id: AuthService.getActiveBranchId(),
                accounting_period_id: AuthService.getActiveAccountingPeriodId(),
                ...data
            },
            { validateStatus: () => true }
        ),
    getProductArticle: (data) =>
        axiosInstance.post(
            '/api/common/getProductArticle',
            {
                branch_id: AuthService.getActiveBranchId(),
                accounting_period_id: AuthService.getActiveAccountingPeriodId(),
                ...data
            },
            { validateStatus: () => true }
        ),
    getProductSizes: (data) =>
        axiosInstance.post(
            '/api/common/getProductSizes',
            {
                branch_id: AuthService.getActiveBranchId(),
                accounting_period_id: AuthService.getActiveAccountingPeriodId(),
                ...data
            },
            { validateStatus: () => true }
        ),
    getProductTiers: (data) =>
        axiosInstance.post(
            '/api/common/getProductTiers',
            {
                branch_id: AuthService.getActiveBranchId(),
                accounting_period_id: AuthService.getActiveAccountingPeriodId(),
                ...data
            },
            { validateStatus: () => true }
        ),
    getProductGrades: (data) =>
        axiosInstance.post(
            '/api/common/getProductGrades',
            {
                branch_id: AuthService.getActiveBranchId(),
                accounting_period_id: AuthService.getActiveAccountingPeriodId(),
                ...data
            },
            { validateStatus: () => true }
        ),
    getPurchaseAccounts: (data) =>
        axiosInstance.post(
            '/api/common/getPurchaseAccounts',
            {
                branch_id: AuthService.getActiveBranchId(),
                accounting_period_id: AuthService.getActiveAccountingPeriodId(),
                ...data
            },
            { validateStatus: () => true }
        ),
    getRoles: (data) =>
        axiosInstance.post(
            '/api/common/getRoles',
            {
                branch_id: AuthService.getActiveBranchId(),
                accounting_period_id: AuthService.getActiveAccountingPeriodId(),
                ...data
            },
            { validateStatus: () => true }
        ),
    getAccountingPeriods: (data) =>
        axiosInstance.post(
            '/api/common/getAccountingPeriods',
            {
                branch_id: AuthService.getActiveBranchId(),
                accounting_period_id: AuthService.getActiveAccountingPeriodId(),
                ...data
            },
            { validateStatus: () => true }
        ),
    getControlAccounts: (data) =>
        axiosInstance.post(
            '/api/common/getControlAccounts',
            {
                branch_id: AuthService.getActiveBranchId(),
                accounting_period_id: AuthService.getActiveAccountingPeriodId(),
                ...data
            },
            { validateStatus: () => true }
        ),
    getControlGeographical: (data) =>
        axiosInstance.post(
            '/api/common/getControlGeographical',
            {
                branch_id: AuthService.getActiveBranchId(),
                accounting_period_id: AuthService.getActiveAccountingPeriodId(),
                ...data
            },
            { validateStatus: () => true }
        ),

    getControlSalesDesignation: (data) =>
        axiosInstance.post(
            '/api/common/getControlSalesDesignation',
            {
                branch_id: AuthService.getActiveBranchId(),
                accounting_period_id: AuthService.getActiveAccountingPeriodId(),
                ...data
            },
            { validateStatus: () => true }
        ),

    getControlAccountSequenceNo: (data) =>
        axiosInstance.post(
            '/api/common/getControlAccountSequenceNo',
            {
                branch_id: AuthService.getActiveBranchId(),
                accounting_period_id: AuthService.getActiveAccountingPeriodId(),
                ...data
            },
            { validateStatus: () => true }
        ),
    getAccountTypes: (data) =>
        axiosInstance.post(
            '/api/common/getAccountTypes',
            {
                branch_id: AuthService.getActiveBranchId(),
                accounting_period_id: AuthService.getActiveAccountingPeriodId(),
                ...data
            },
            { validateStatus: () => true }
        ),
    getPartyByParams: (data) =>
        axiosInstance.post(
            '/api/common/getPartyByParams',
            {
                branch_id: AuthService.getActiveBranchId(),
                accounting_period_id: AuthService.getActiveAccountingPeriodId(),
                ...data
            },
            {
                validateStatus: () => true
            }
        ),
    getSecondaryPartyByParams: (data) =>
        axiosInstance.post(
            '/api/common/getSecondaryPartyByParams',
            {
                branch_id: AuthService.getActiveBranchId(),
                accounting_period_id: AuthService.getActiveAccountingPeriodId(),
                ...data
            },
            {
                validateStatus: () => true
            }
        ),
    getAccountByParams: (data) =>
        axiosInstance.post(
            '/api/common/getAccountByParams',
            {
                branch_id: AuthService.getActiveBranchId(),
                accounting_period_id: AuthService.getActiveAccountingPeriodId(),
                ...data
            },
            {
                validateStatus: () => true
            }
        ),
    getCombineAccountsView: (data) =>
        axiosInstance.post(
            '/api/common/getCombineAccountsView',
            {
                branch_id: AuthService.getActiveBranchId(),
                accounting_period_id: AuthService.getActiveAccountingPeriodId(),
                ...data
            },
            {
                validateStatus: () => true
            }
        ),
    getVoucherTypeDependencies: (data) =>
        axiosInstance.post(
            '/api/common/getVoucherTypeDependencies',
            {
                branch_id: AuthService.getActiveBranchId(),
                accounting_period_id: AuthService.getActiveAccountingPeriodId(),
                ...data
            },
            {
                validateStatus: () => true
            }
        ),
    getProductRowRack: (data) =>
        axiosInstance.post(
            '/api/common/getProductRowRack',
            {
                branch_id: AuthService.getActiveBranchId(),
                accounting_period_id: AuthService.getActiveAccountingPeriodId(),
                ...data
            },
            {
                validateStatus: () => true
            }
        ),
    getWarehouse: (data) =>
        axiosInstance.post(
            '/api/common/getWarehouse',
            {
                branch_id: AuthService.getActiveBranchId(),
                accounting_period_id: AuthService.getActiveAccountingPeriodId(),
                ...data
            },
            {
                validateStatus: () => true
            }
        ),
    getAccountsGroupMapping: (data) =>
        axiosInstance.post(
            '/api/common/getAccountsGroupMapping',
            {
                branch_id: AuthService.getActiveBranchId(),
                accounting_period_id: AuthService.getActiveAccountingPeriodId(),
                ...data
            },
            {
                validateStatus: () => true
            }
        ),
    getProductByParams: (data) =>
        axiosInstance.post(
            '/api/common/getProductByParams',
            {
                branch_id: AuthService.getActiveBranchId(),
                accounting_period_id: AuthService.getActiveAccountingPeriodId(),
                ...data
            },
            {
                validateStatus: () => true
            }
        ),
    getAccountGroupMappingByParams: (data) =>
        axiosInstance.post(
            '/api/common/getAccountGroupMappingByParams',
            {
                branch_id: AuthService.getActiveBranchId(),
                accounting_period_id: AuthService.getActiveAccountingPeriodId(),
                ...data
            },
            {
                validateStatus: () => true
            }
        ),
    getCurrentBillOfMaterial: (data) =>
        axiosInstance.post(
            '/api/common/getCurrentBillOfMaterial',
            {
                branch_id: AuthService.getActiveBranchId(),
                accounting_period_id: AuthService.getActiveAccountingPeriodId(),
                ...data
            },
            {
                validateStatus: () => true
            }
        ),
    getProductSalesDiscount: (data) =>
        axiosInstance.post(
            '/api/common/getProductSalesDiscount',
            {
                branch_id: AuthService.getActiveBranchId(),
                accounting_period_id: AuthService.getActiveAccountingPeriodId(),
                ...data
            },
            {
                validateStatus: () => true
            }
        ),
    getCurrentSalesDiscountPolicy: (data) =>
        axiosInstance.post(
            '/api/common/getCurrentSalesDiscountPolicy',
            {
                branch_id: AuthService.getActiveBranchId(),
                accounting_period_id: AuthService.getActiveAccountingPeriodId(),
                ...data
            },
            {
                validateStatus: () => true
            }
        ),
    getLastProductProductionHistory: (data) =>
        axiosInstance.post(
            '/api/common/getLastProductProductionHistory',
            {
                branch_id: AuthService.getActiveBranchId(),
                accounting_period_id: AuthService.getActiveAccountingPeriodId(),
                ...data
            },
            {
                validateStatus: () => true
            }
        ),
    getLastFinishedProductProductionHistory: (data) =>
        axiosInstance.post(
            '/api/common/getLastFinishedProductProductionHistory',
            {
                branch_id: AuthService.getActiveBranchId(),
                accounting_period_id: AuthService.getActiveAccountingPeriodId(),
                ...data
            },
            {
                validateStatus: () => true
            }
        ),
    getCurrentBillOfMaterialDetailForRawProduction: (data) =>
        axiosInstance.post(
            '/api/common/getCurrentBillOfMaterialDetailForRawProduction',
            {
                branch_id: AuthService.getActiveBranchId(),
                accounting_period_id: AuthService.getActiveAccountingPeriodId(),
                ...data
            },
            {
                validateStatus: () => true
            }
        ),
    getCurrentBillOfMaterialDetailForFinishedProduction: (data) =>
        axiosInstance.post(
            '/api/common/getCurrentBillOfMaterialDetailForFinishedProduction',
            {
                branch_id: AuthService.getActiveBranchId(),
                accounting_period_id: AuthService.getActiveAccountingPeriodId(),
                ...data
            },
            {
                validateStatus: () => true
            }
        ),
    getCurrentFinishedProductBillOfMaterial: (data) =>
        axiosInstance.post(
            '/api/common/getCurrentFinishedProductBillOfMaterial',
            {
                branch_id: AuthService.getActiveBranchId(),
                accounting_period_id: AuthService.getActiveAccountingPeriodId(),
                ...data
            },
            {
                validateStatus: () => true
            }
        ),
    getCurrentCompositionOfMaterial: (data) =>
        axiosInstance.post(
            '/api/common/getCurrentCompositionOfMaterial',
            {
                branch_id: AuthService.getActiveBranchId(),
                accounting_period_id: AuthService.getActiveAccountingPeriodId(),
                ...data
            },
            {
                validateStatus: () => true
            }
        ),
    getCurrentCompositionOfMaterialDetail: (data) =>
        axiosInstance.post(
            '/api/common/getCurrentCompositionOfMaterialDetail',
            {
                branch_id: AuthService.getActiveBranchId(),
                accounting_period_id: AuthService.getActiveAccountingPeriodId(),
                ...data
            },
            {
                validateStatus: () => true
            }
        ),
    getRowRackByParams: (data) =>
        axiosInstance.post(
            '/api/common/getRowRackByParams',
            {
                branch_id: AuthService.getActiveBranchId(),
                accounting_period_id: AuthService.getActiveAccountingPeriodId(),
                ...data
            },
            {
                validateStatus: () => true
            }
        ),

    getHistoryParams: (data) =>
        axiosInstance.post(
            '/api/common/getHistoryParams',
            {
                branch_id: AuthService.getActiveBranchId(),
                accounting_period_id: AuthService.getActiveAccountingPeriodId(),
                ...data
            },
            {
                validateStatus: () => true
            }
        ),
    getVoucherDetailAudit: (data) =>
        axiosInstance.post(
            '/api/common/getVoucherDetailAudit',
            {
                branch_id: AuthService.getActiveBranchId(),
                accounting_period_id: AuthService.getActiveAccountingPeriodId(),
                ...data
            },
            {
                validateStatus: () => true
            }
        ),
    getVoucherDetailMaster: (data) =>
        axiosInstance.post(
            '/api/common/getVoucherDetailMaster',
            {
                branch_id: AuthService.getActiveBranchId(),
                accounting_period_id: AuthService.getActiveAccountingPeriodId(),
                ...data
            },
            {
                validateStatus: () => true
            }
        ),
    getGeneralAccountMapping: (data) =>
        axiosInstance.post(
            '/api/common/getGeneralAccountMapping',
            {
                branch_id: AuthService.getActiveBranchId(),
                accounting_period_id: AuthService.getActiveAccountingPeriodId(),
                ...data
            },
            {
                validateStatus: () => true
            }
        ),
    getApprovalStageParams: (data) =>
        axiosInstance.post(
            '/api/common/getApprovalStageParams',
            {
                branch_id: AuthService.getActiveBranchId(),
                accounting_period_id: AuthService.getActiveAccountingPeriodId(),
                ...data
            },
            {
                validateStatus: () => true
            }
        )
};
